import { accessRole } from "../../../../helpers/access_role"
import ErrorAccess from "../../../../components/Error/Content/Access"
import PenilaianPegawaiComponent from "./Sections/PenilaianPegawaiComponent"
import PenialianPegawaiDetailComponent from "./Sections/PenialianPegawaiDetailComponent"
import PenialianPegawaiIndexComponent from "./Sections/PenialianPegawaiIndexComponent"

const RouteView = (props) => {

   const queryParams = new URLSearchParams(props.location.search);
   const section = queryParams.get('section');
   const uuid = queryParams.get('uuid');
   const currentRoleId = JSON.parse(localStorage.getItem("currentRoleId"));

   // ROLE PEGAWAI
   if(parseInt(currentRoleId) === 2){
       if ((section !== undefined && section !== null) && (uuid !== undefined && uuid !== null)) {
         if (section === 'detail') {
            return <PenilaianPegawaiComponent />
         } else if (section === 'assessment') {
            return <PenialianPegawaiDetailComponent />
         } else {
            return <ErrorAccess />
         }
      }
      return <PenialianPegawaiIndexComponent />
   }else{
      return <ErrorAccess />
   }
   
}
export default RouteView